var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"id":"svg-circle","viewBox":"0 0 24 24","fill":"none"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 18a6 6 0 100-12 6 6 0 000 12zm0 2a8 8 0 100-16 8 8 0 000 16z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }